import React, { useState, useEffect } from "react";
//Icons svg
import { ReactComponent as Labels11 } from "../../../../assets/images/labels1-1.svg";
//Templates
import ReclamationsTemplate from "../reclamation/ReclamationsTemplate";

const PrintOrderReclamationButton = () => {
  //States
  const [frameTarget, setFrameTarjet] = useState("");
  const [isReclamationReady, setIsReclamationReady] = useState(false);

  //Functions
  const retrieveAction = (e) => {
    setIsReclamationReady(true);
  };

  const sendToPrint = (frameTarget) => {
    var content = document.getElementById(frameTarget);

    var pri = document.getElementById("documents-to-print").contentWindow;
    pri.document.open();
    pri.document.write(content.innerHTML);
    pri.document.close();
    pri.focus();
    pri.print();
    setFrameTarjet("");
    setIsReclamationReady(false);
  };

  //useEffect
  useEffect(() => {
    if (frameTarget !== "") {
      sendToPrint(frameTarget);
    }
  }, [frameTarget]);

  return (
    <div className="print-document__container reclamation">
      <div className="print-document__texts-container">
        <h2 className="print-document__texts-title">Reclamaciones</h2>
      </div>
      <div className="print-document__buttons-container">
        <div className="print-document__button-container">
          <div
            className="hitPoint"
            data-type="reclamation"
            onClick={retrieveAction}
          ></div>
          <div className="print-document__buttons-icon">
            <Labels11 />
          </div>
          <div className="print-document__buttons-texts">
            <h2 className="print-document__texts-title"> </h2>
            <p className="print-document__texts-text">
              Hojas de reclamaciones o confirmación de entrega.
            </p>
          </div>
        </div>
      </div>
      {isReclamationReady && (
        <ReclamationsTemplate setFrameTarjet={setFrameTarjet} />
      )}
    </div>
  );
};

export default PrintOrderReclamationButton;
